export default {
    methods: {
        showToast(msg, title, type, options) {

            const defaultOptions = { position: 'center' }

            const realOptions = options ? options : defaultOptions

            return this.$toast[type](msg, title, realOptions)            

        },
    },
};